import React from "react";
import { Globe } from "lucide-react";
import { useApp } from "../contexts/AppContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from "./ui/dropdown-menu";
import t from "../lib/i18n";

/**
 * Small calm language picker used on pre-auth surfaces (Landing, Auth, Forgot/Reset).
 * Mirrors the in-app Layout menu, but doesn't require an authenticated parent.
 * Persists immediately via AppContext.setLanguage which writes to localStorage.
 */
export const LanguagePicker = () => {
  const { language, setLanguage } = useApp();
  const labels = { en: "EN", es: "ES" };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="bn-pill text-sm flex items-center gap-2"
          style={{ background: "var(--bn-surface)" }}
          data-testid="lang-picker-trigger"
          aria-label={t(language, "languageMenu")}
        >
          <Globe size={14} aria-hidden="true" />
          <span>{labels[language] || "EN"}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-2xl">
        <DropdownMenuLabel>{t(language, "language")}</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => setLanguage("en")} data-testid="lang-picker-en">
          English
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLanguage("es")} data-testid="lang-picker-es">
          Español
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguagePicker;
